import { Component, ElementRef, OnInit, VERSION, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import * as bcrypt from 'bcryptjs';
import { ClienteService } from 'src/app/services/api/cliente.service';
import { LoginService } from 'src/app/services/api/login.service';
import { ProductoDTOService } from 'src/app/services/api/productoDTO.service';
import { TokenStorageServiceCliente } from 'src/app/services/api/TokenStorageServiceCliente';


@Component({
  selector: 'app-registro-cliente',
  templateUrl: './registro-cliente.component.html',
  styleUrls: ['./registro-cliente.component.css']
})

export class RegistroClienteComponent implements OnInit {

  formRegistroCliente!: FormGroup;
  name = "Angular " + VERSION.major;
  password: string = "";
  hashedPassword: any;
  hashedPasswordNow:any;
  valid?: boolean;
  show: boolean = false;
  codigoCliente:number=0;
  lblRespuesta = true;
  displayStyle: any;
  esperar=false;
  errorForm:String[]=["0","0","0"];
  checkBoxValue: any = false;
  correo:string="";
  esconderForm:boolean=false;
  noExisteMovil = false;
  codigoClienteDTO?:String="";
  isLoggedIn = false;
  isLoginFailed = false;
  roles: string[] = [];
  tipoLogeo:number=0;
  nTelefonoSesion:String="";
constructor(
  private clienteService2:ProductoDTOService,
  private clienteService:ClienteService,
  private router:Router,
  private loginService : LoginService,
  private tokenStorage: TokenStorageServiceCliente,
  private activatedRoute : ActivatedRoute,
){

  activatedRoute.params.subscribe( prm => {
    console.log(`El id es: ${prm['idTipo']}`);
    this.tipoLogeo=prm['idTipo'];

})

}


  ngOnInit(): void {





    this.formRegistroCliente = new FormGroup({
      'txtNombre' : new FormControl('', Validators.required),
      'txtApellido' : new FormControl('', Validators.required),
      'txtMovil' : new FormControl('', Validators.required),
      'txtCorreo' : new FormControl('', Validators.required)
    });
  }


  OnRegistraCliente(){

    var min = 1000000;
    var max = 2000000;
    
    var x = Math.floor(Math.random()*(max-min+1)+min);
    
    this.codigoCliente=x;
    this.password=this.codigoCliente.toString();
    this.hashPassword();
    this.OnNuevoCliente();

    

  }

 // Converting password into hash-data before sending to the server
 hashPassword() {
  const salt = bcrypt.genSaltSync(10);
  this.hashedPassword = bcrypt.hashSync(this.password, salt);
//alert( this.hashedPassword);

}

// authentication at client-side
authenticate(password: any) {
  this.show = true;
  this.valid = bcrypt.compareSync(password, this.hashedPassword);
}


OnNuevoCliente(){

 

if (this.ValidarModificaRegistro()==0){


var _nombre= this.formRegistroCliente.value['txtNombre'];
var _apellido= this.formRegistroCliente.value['txtApellido'];

  this.esperar=true;
  this.hashedPasswordNow= this.hashedPassword.replaceAll('/', '-');


if (this.formRegistroCliente.value['txtCorreo']!==""){

this.correo=this.formRegistroCliente.value['txtCorreo'];
}else {

  this.correo="NINGUNO";
}

//alert(this.correo);


  this.clienteService.nuevoCliente(
   _nombre.toUpperCase(),
  _apellido.toUpperCase(),
  this.formRegistroCliente.value['txtMovil'],
  this.hashedPasswordNow,
this.codigoCliente.toString(),
this.correo
  ).subscribe(response =>{
    console.log(response)
    this.nTelefonoSesion=this.formRegistroCliente.value['txtMovil'];
    if (response.toString()=="1"){
      this.esperar=false;
      this.lblRespuesta=true;
      this.displayStyle = "block"; 
      this.formRegistroCliente.controls['txtNombre'].setValue("");
      this.formRegistroCliente.controls['txtApellido'].setValue("");
      this.formRegistroCliente.controls['txtMovil'].setValue("");
      this.formRegistroCliente.controls['txtCorreo'].setValue("");
      this.esconderForm=true;
    }

    if (response.toString()=="0"){
      this.esperar=false;
     this.lblRespuesta=false;
     this.formRegistroCliente.controls['txtNombre'].setValue("");
     this.formRegistroCliente.controls['txtApellido'].setValue("");
     this.formRegistroCliente.controls['txtMovil'].setValue("");
     this.formRegistroCliente.controls['txtCorreo'].setValue("");
  
     }
  
  })


}

 }

 OnIniciarSesion(){
  this.router.navigate(['/login-cliente/1'])
 }

OnIraInicio(){
  this.router.navigate(['/inicio'])
}

 ValidarModificaRegistro(){
  let rs:number=0;
  let r1:number=0;
  let r2:number=0;
  let r3:number=0;
  let r4:number=0;


  if (this.formRegistroCliente.value['txtNombre']!==""){
    this.errorForm[0]="0";
    r1= 0;
  }else {
    this.errorForm[0]="1";
    r1= 1;
  }


  if (this.formRegistroCliente.value['txtApellido']!==""){
    this.errorForm[1]="0";
    r2= 0;
  }else {
    this.errorForm[1]="1";
    r2= 1;
  }


  if (this.formRegistroCliente.value['txtMovil']!==""){
    this.errorForm[2]="0";
    r3= 0;
  }else {
    this.errorForm[2]="1";
    r3= 1;
  }

  if (this.checkBoxValue==true){
    this.errorForm[3]="0";
    r4= 0;
  }else {
    this.errorForm[3]="1";
    r4= 1;
  }


  


  rs=r1+r2+r3+r4;

return rs;

}

checkCheckBoxvalue(){
  console.log(this.checkBoxValue)
}



OnBuscarMovil(movil:String){

  //localStorage.removeItem('cliente_stg');



   this.clienteService2.getClienteByMovil(movil).subscribe( response =>{
    localStorage.setItem('cliente_stg', JSON.stringify(response));

    if (response.length>0){
  this.noExisteMovil=false;
  for (let datosCliente of response){
     
    this.codigoClienteDTO=datosCliente.codigoCliente
  }
  this.GetRepuesta();



}else {
  this.noExisteMovil=true;
}



    
   }
  );
  






}


GetRepuesta(){


  this.ValidarUsuario(this.codigoClienteDTO);
}

ValidarUsuario(codigocliente:any){

  if (codigocliente!==""){

    this.loginService.login(codigocliente,codigocliente).subscribe(
          data => {
            this.tokenStorage.saveToken(data.accessToken);
            this.tokenStorage.saveUser(data);
            this.isLoginFailed = false;
            this.isLoggedIn = true;
            this.roles = this.tokenStorage.getUser().roles;
           
            //this.reloadPage();

            if (this.tipoLogeo==1){
              this.router.navigateByUrl('/carrito');
              localStorage.setItem('ejecutaCompra','1');
            }

         
            if (this.tipoLogeo==2){
              
              this.router.navigateByUrl('/cambio');
            }

            if (this.tipoLogeo==3){
              
              this.router.navigateByUrl('/pedido-cliente');
            }

          
           
          },
          err => {
         
            this.isLoginFailed = true;
            console.log("No existe cuenta");
      
           
          }
        );
     
  
  }else {
  
       this.isLoginFailed = true;
             console.log("No existe cuenta");
      
         
  
  }
  

}



onSubmitSesion() {

 
  if (this.nTelefonoSesion!==""){


//  this.OnBuscarMovil(this.formLoginCliente.value['txtClave']);


this.OnBuscarMovil(this.nTelefonoSesion)+"";



  }


  }


}
